/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameWithPlayTime } from './GameWithPlayTime';
import {
    GameWithPlayTimeFromJSON,
    GameWithPlayTimeFromJSONTyped,
    GameWithPlayTimeToJSON,
    GameWithPlayTimeToJSONTyped,
} from './GameWithPlayTime';

/**
 * 
 * @export
 * @interface GetFavoriteGamesResponse
 */
export interface GetFavoriteGamesResponse {
    /**
     * 
     * @type {Array<GameWithPlayTime>}
     * @memberof GetFavoriteGamesResponse
     */
    games?: Array<GameWithPlayTime>;
}

/**
 * Check if a given object implements the GetFavoriteGamesResponse interface.
 */
export function instanceOfGetFavoriteGamesResponse(value: object): value is GetFavoriteGamesResponse {
    return true;
}

export function GetFavoriteGamesResponseFromJSON(json: any): GetFavoriteGamesResponse {
    return GetFavoriteGamesResponseFromJSONTyped(json, false);
}

export function GetFavoriteGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFavoriteGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'games': json['games'] == null ? undefined : ((json['games'] as Array<any>).map(GameWithPlayTimeFromJSON)),
    };
}

export function GetFavoriteGamesResponseToJSON(json: any): GetFavoriteGamesResponse {
    return GetFavoriteGamesResponseToJSONTyped(json, false);
}

export function GetFavoriteGamesResponseToJSONTyped(value?: GetFavoriteGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'games': value['games'] == null ? undefined : ((value['games'] as Array<any>).map(GameWithPlayTimeToJSON)),
    };
}

